import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowUp_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.29289 18.7071C5.90237 18.3166 5.90237 17.6834 6.29289 17.2929L19.2929 4.29289C19.4804 4.10536 19.7348 4 20 4C20.2652 4 20.5196 4.10536 20.7071 4.29289L33.7071 17.2929C34.0976 17.6834 34.0976 18.3166 33.7071 18.7071C33.3166 19.0976 32.6834 19.0976 32.2929 18.7071L21 7.41422L21 35C21 35.5523 20.5523 36 20 36C19.4477 36 19 35.5523 19 35L19 7.41422L7.70711 18.7071C7.31658 19.0976 6.68342 19.0976 6.29289 18.7071Z"
            />
        </SvgStyled>
    );
};

export default ArrowUp_xl;
